export default "__VITE_ASSET__CemQrTwK__"